import React from 'react';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const AnonymizationProfilesHelp = ({ t }) => {
  const [open, setOpen] = React.useState(true);
  const collapseId = 'anonymization-profiles-help';

  return (
    <Alert
      icon={<HelpOutlineIcon sx={{ mt: 0.5 }} />}
      severity="info"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
        py: 1.5,
        px: 2,
      }}
      action={
        <IconButton
          size="small"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={collapseId}
          aria-label={
            open
              ? t?.('anonymizationProfiles.help.collapse', 'Skryť návod')
              : t?.('anonymizationProfiles.help.expand', 'Zobraziť návod')
          }
          sx={{ mt: 0.5, color: 'inherit' }}
        >
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      }
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t?.('anonymizationProfiles.help.title', 'Ako fungujú anonymizačné profily')}
      </Typography>

      <Collapse in={open} timeout="auto" id={collapseId}>
        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'anonymizationProfiles.help.p1',
              'Chcete anonymizovať dokumenty podľa vlastných preferencií? Je to jednoduché - stačí si vytvoriť anonymizačný profil.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'anonymizationProfiles.help.p2',
              'Kliknite na Vytvoriť, vyberte údaje, farby použité pri anonymizácii a slovné spojenia, ktoré chcete anonymizovať. Profil si následne uložte.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'anonymizationProfiles.help.p3',
              'Uložené profily môžete používať opakovane pri anonymizácii súborov bez nutnosti opätovného nastavovania.'
            )}
          </Typography>

          <Box 
            sx={(theme) => ({ 
                mt: 1, 
                p: 1.5, 
                borderRadius: 1.5,
                border: '1px dashed',
                borderColor: 'info.main',
                bgcolor: alpha(theme.palette.info.main, 0.08)
            })}
          >
            <Typography variant="body2" sx={{ display: 'block', fontWeight: 600, color: 'info.main' }}>
              💡 {t?.('anonymizationProfiles.help.tipsTitle', 'Máte špeciálne požiadavky?')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
              {t?.(
                'anonymizationProfiles.help.tip1',
                'Napíšte nám prostredníctvom kontaktov uvedených v menu „O programe“ a pripravíme vám riešenie na mieru - anonymizáciu, skracovanie, nahrádzanie alebo iné úpravy obsahu dokumentov.'
              )}
            </Typography>
          </Box>
        </Stack>
      </Collapse>
    </Alert>
  );
};

export default AnonymizationProfilesHelp;